import React, {type JSX} from 'react';
import {AppBar} from '@mui/material';
import {styled} from '@mui/material/styles';
import Logo from './logo';

const StyledAppBar = styled(AppBar)(({theme}) => ({
  padding: theme.spacing(4, 8),
}));

function Header(): JSX.Element {
  return (
    <StyledAppBar elevation={0} position="relative">
      <Logo />
    </StyledAppBar>
  );
}

export default Header;
